import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'translate',
	standalone: true, // Falls du Angular 15+ mit Standalone Components nutzt
})
export class TranslateEnumPipe implements PipeTransform {
	transform(value: string | null | undefined, prefix: string, tFn: (key: string) => string): string {
		if (value == null) {
			return '';
		}
		return tFn(`${prefix}.${value}`);
	}
}
